import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/fornecedores/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}/despesasdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarDespesas(pagamentoDespesas) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoDespesas.pagamentoId}/associardespesas`,
                pagamentoDespesas
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarDespesa(pagamentoDespesa) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoDespesa.pagamentoId}/desassociardespesa`,
                pagamentoDespesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento() {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/pagamentos/`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .post(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoAnexoId', pagamentoAnexo.pagamentoAnexoId)
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .patch(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/fornecedores/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/anexos/${pagamentoAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/anexos/${pagamentoAnexoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/pagamentos/enviar`, pagamentoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/sgtec/uabs/pagamentos/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal(notaFiscal) {
        const formData = new FormData()
        Object.keys(notaFiscal).forEach(chave => {
            if (notaFiscal[chave] !== null && notaFiscal[chave] !== undefined) {
                formData.append(chave, notaFiscal[chave])
            }
        })

        return axiosJwt
            .post(
                `${api}/despesasgerais/fornecedores/pagamentos/${notaFiscal.pagamentoId}/notasfiscais`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirNotaFiscal(pagamentoId, pagamentoNotaFiscalId) {
        return axiosJwt
            .delete(`${api}/despesasgerais/fornecedores/pagamentos/${pagamentoId}/notasfiscais/${pagamentoNotaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/pagamentos/notasfiscais/${pagamentoNotaFiscalId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}